// Announcement

function initCookies() {
    var cookieName = "cookieNotice";
    var $cookieNotice = $(".cookie-notice");

    $('.cookie-notice__close').click(function () {

        var date2 = new Date();
        //console.log(moment(date2).format('YYYY-MM-DD , h:mm:ss a '));
        $cookieNotice.addClass('cookie-notice--hide');

        //Need to specify PM 
        Cookies.set(cookieName, { createdDate: moment(date2, 'YYYY-MM-DD ,h:mm:ss A').format('YYYY-MM-DD , h:mm:ss a') }, {
            expires: 365,
        });

    });

    if (Cookies.get(cookieName)) {
        //console.log('cookies hide');
        $cookieNotice.addClass('cookie-notice--hide');
    } else {
        //console.log('cookies show');
        $cookieNotice.removeClass('cookie-notice--hide');
    }

};

function deferCookies(method) {
    if (window.jQuery) {
        //console.log('All loaded and ready for cookie notice cookies');
        method();
    }
    else {
        setTimeout(function () { defer(method) }, 50);
    }
}

deferCookies(function () {
    initCookies();
});